import * as React from 'react'
import { Card, Descriptions, Space, Typography } from 'antd'
import { DepositEdit } from '../../edit/types'

type Props = {
  deposit: DepositEdit
}

export const DepositComposition = ({ deposit }: Props) => {
  if (!deposit.order && !deposit.hotBuyOrder) return null

  return (
    <Card size="small" title="Composition">
      {deposit.order && (
        <div style={{ marginBottom: 16 }}>
          <Typography.Title level={5}>
            {`Order ID: ${deposit.order.orderId}`}
          </Typography.Title>
          <Space wrap size={12} align="start">
            {deposit.order.orderItems.map((item, index) => (
              <Descriptions
                key={item.PropertyID + index}
                size="small"
                column={1}
                bordered
                title={`Property №${index + 1}`}
              >
                <Descriptions.Item label="Property ID">
                  {item.PropertyID}
                </Descriptions.Item>
                <Descriptions.Item label="Property name">
                  {item.PropertyName}
                </Descriptions.Item>
                <Descriptions.Item label="Number of tokens">
                  {item.Amount}
                </Descriptions.Item>
                <Descriptions.Item label="Token price">
                  {item.TokenPrice}
                </Descriptions.Item>
                <Descriptions.Item label="Total order amount">
                  {item.Price}
                </Descriptions.Item>
              </Descriptions>
            ))}
          </Space>
        </div>
      )}

      {deposit.hotBuyOrder && (
        <div>
          <Typography.Title level={5}>
            {`Hot buy order ID: ${deposit.hotBuyOrder.id}`}
          </Typography.Title>
          <Space wrap size={12} align="start">
            {deposit.hotBuyOrder.items.map((item, index) => (
              <Descriptions
                key={item.PropertyID + index}
                size="small"
                column={1}
                bordered
                title={`Property №${index + 1}`}
              >
                <Descriptions.Item label="Property ID">
                  {item.PropertyID}
                </Descriptions.Item>
                <Descriptions.Item label="Property name">
                  {item.PropertyName}
                </Descriptions.Item>
                <Descriptions.Item label="Number of tokens">
                  {item.TokenAmount}
                </Descriptions.Item>
                <Descriptions.Item label="Token price">
                  {item.TokenPriceTaker}
                </Descriptions.Item>
                <Descriptions.Item label="Total order amount">
                  {item.TotalPriceTaker}
                </Descriptions.Item>
              </Descriptions>
            ))}
          </Space>
        </div>
      )}
    </Card>
  )
}
